import { ethers } from 'ethers';
import 'reflect-metadata';

const requiredMetadataKey = Symbol('required');

export function required(target: Record<string, any>, propertyKey: string | symbol, parameterIndex: number): void {
  const existingRequiredParameters: number[] = Reflect.getOwnMetadata(requiredMetadataKey, target, propertyKey) || [];
  existingRequiredParameters.push(parameterIndex);
  Reflect.defineMetadata(requiredMetadataKey, existingRequiredParameters, target, propertyKey);
}

function getAddress(arg: any | string): any {
  if (typeof arg == 'object') {
    arg = getAddresses(arg);
  } else if (typeof arg == 'string') {
    arg = ethers.utils.getAddress(arg);
  }
  return arg;
}

function getAddresses(arg: any): any {
  if (arg?.addresses) {
    arg.addresses = arg.addresses.map((address: string) => {
      return ethers.utils.getAddress(address);
    });
  } else if (arg?.fromList && arg?.toList) {
    arg.fromList = arg.fromList.map((address: string) => {
      return ethers.utils.getAddress(address);
    });
    arg.toList = arg.toList.map((address: string) => {
      return ethers.utils.getAddress(address);
    });
  } else if (arg?.toList) {
    arg.toList = arg.toList.map((address: string) => {
      return ethers.utils.getAddress(address);
    });
  } else if (arg?.userAddresses && arg?.identityAddresses) {
    arg.userAddresses = arg.userAddresses.map((address: string) => {
      return ethers.utils.getAddress(address);
    });
    arg.identityAddresses = arg.identityAddresses.map((address: string) => {
      return ethers.utils.getAddress(address);
    });
  } else if (arg?.address && arg?.identityAddress) {
    arg.address = ethers.utils.getAddress(arg.address);
    arg.identityAddress = ethers.utils.getAddress(arg.identityAddress);
  } else if (arg?.from && arg?.to) {
    arg.from = ethers.utils.getAddress(arg.from);
    arg.to = ethers.utils.getAddress(arg.to);
  } else if (arg?.to) {
    arg.to = ethers.utils.getAddress(arg.to);
  } else if (arg?.address) {
    arg.address = ethers.utils.getAddress(arg.address);
  }
  return arg;
}

export function addressesFormat() {
  return function (target: any, propertyName: string, descriptor: any) {
    const method = descriptor.value;
    descriptor.value = async function (...args: any[]): Promise<any> {
      const requiredParameters: number[] = Reflect.getOwnMetadata(requiredMetadataKey, target, propertyName);
      if (requiredParameters) {
        if (args[0]) {
          try {
            args[0] = getAddress(args[0]);
          } catch (e) {
            throw new Error('Wrong Address Format');
          }
        }
        return method.apply(this, args);
      }
    };
  };
}
